import { render, staticRenderFns } from "./CreatePromocode.vue?vue&type=template&id=09b8b92c&scoped=true&"
import script from "./CreatePromocode.vue?vue&type=script&lang=js&"
export * from "./CreatePromocode.vue?vue&type=script&lang=js&"
import style0 from "./CreatePromocode.vue?vue&type=style&index=0&id=09b8b92c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b8b92c",
  null
  
)

export default component.exports